/*
 * Created by Anup Shrestha (anup.stha012@gmail.com)
 * Copyright (c) 2022.  All rights reserved.
 * Last modified 5/9/22, 1:12 PM
 *
 */

import NavItem from 'components/layout/Sidebar/NavItem/NavItem';

export default NavItem;
